import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {RootRoutingModule} from './root-routing.module';
import {HomepageComponent} from './homepage/homepage.component';
import {PrivacyComponent} from './privacy/privacy.component';
import {CookiesComponent} from './cookies/cookies.component';
import {GalleriesModule} from '../../components/galleries/galleries.module';
import {HomepageModule} from '../../components/homepage/homepage.module';
import {SearchComponent} from './search/search.component';
import {TranslateModule} from '@ngx-translate/core';
import {NotFoundComponent} from './not-found/not-found.component';
import {PipesModule} from '../../providers/pipes/pipes.module';
import {DirectivesModule} from '../../providers/directives/directives.module';
import {LayoutModule} from "../../layout/layout.module";


@NgModule({
  declarations: [HomepageComponent, PrivacyComponent, CookiesComponent, SearchComponent, NotFoundComponent],
    imports: [
        CommonModule,
        RootRoutingModule,
        GalleriesModule,
        HomepageModule,
        TranslateModule,
        PipesModule,
        DirectivesModule,
        LayoutModule
    ]
})
export class RootModule {
}
